import * as _ from "lodash";

import { memoize } from "@ctra/utils";
import { GamePlanTaskEventView, ImpactTrackedEventPage } from "@events";

import { EventBase } from "./Base";
import { GamePlanTaskEventContext } from "@ctra/api";
import { Enterprise, i18nTranslate } from "@ctra/i18n";

/**
 * Game plan task event
 */
class GamePlanTaskEvent extends EventBase {
  @memoize
  getTitle(): string {
    return _.defaultTo(this.entity.title, "");
  }

  @memoize
  getComponents(): ReturnType<typeof EventBase.prototype.getComponents> {
    return {
      ...super.getComponents(),
      Page: ImpactTrackedEventPage,
      View: GamePlanTaskEventView
    };
  }

  /**
   * Get the metadata for the event
   */
  @memoize
  getContext(): {
    urlParams: Map<string, unknown>;
    ctaText: string;
  } & GamePlanTaskEventContext {
    const {
      source: { type },
      context: { gamePlanID, sourceState, impactTrackingState }
    } = this.entity;

    const {
      events: {
        entity: { ctaText: cta }
      }
    } = Enterprise;

    return {
      urlParams: new Map([["gamePlanID", gamePlanID]]),
      ctaText: i18nTranslate(cta(type)),
      status: impactTrackingState,
      sourceState
    };
  }
}

export { GamePlanTaskEvent };
